import { render, staticRenderFns } from "./DeleteAnswerModal.vue?vue&type=template&id=7840ed3e"
import script from "./DeleteAnswerModal.vue?vue&type=script&lang=js"
export * from "./DeleteAnswerModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports